export const genderOptions = [
    {value: 1, label: 'Male'},
    {value: 2, label: 'Female'},
];